// Types and helpers shared by the support inbox (pages/SupportInbox.tsx) and
// the conversation panel. Backend: Backend/app/api/admin_support.py.

export const API = 'https://api.lifeshare.app/api/v1/admin/support';

export interface SupportUser { id: number; username: string; full_name?: string; email?: string | null }
export interface SupportThread {
    id: number; title?: string | null; status: 'open' | 'resolved'; unread: number; last_message_at: string;
    preview?: string; feedback_type?: string | null; user: SupportUser;
    app_version?: string | null; platform?: string | null; os_version?: string | null;
    language?: string | null; circles: number;
}
export interface SupportMessage {
    id: number; sender: 'user' | 'admin'; body: string; subject?: string | null;
    feedback_type?: string | null; rating?: number | null; attachment_url?: string | null;
    repeat_count: number; created_at: string; delivered_push?: boolean; delivered_email?: boolean;
}

export const TYPE_LABELS: Record<string, [string, string]> = {
    bug: ['Hata', 'bg-red-100 text-red-700'],
    feature: ['Öneri', 'bg-amber-100 text-amber-700'],
    question: ['Soru', 'bg-blue-100 text-blue-700'],
    general: ['Genel', 'bg-gray-100 text-gray-700'],
};

const FLAGS: Record<string, string> = {
    tr: '🇹🇷', en: '🇺🇸', de: '🇩🇪', es: '🇪🇸', fr: '🇫🇷', it: '🇮🇹', pt: '🇧🇷', nl: '🇳🇱', pl: '🇵🇱',
    ru: '🇷🇺', ar: '🇸🇦', zh: '🇨🇳', ja: '🇯🇵', ko: '🇰🇷', hi: '🇮🇳', id: '🇮🇩', vi: '🇻🇳',
};
export const flag = (lang?: string | null) => (lang && FLAGS[lang]) || '🌐';

export const timeAgo = (iso: string) => {
    const s = (Date.now() - new Date(iso).getTime()) / 1000;
    if (s < 60) return 'şimdi';
    if (s < 3600) return `${Math.floor(s / 60)} dk`;
    if (s < 86400) return `${Math.floor(s / 3600)} sa`;
    if (s < 172800) return 'dün';
    return new Date(iso).toLocaleDateString('tr-TR', { day: 'numeric', month: 'short' });
};

// Ready answers in the user's language (tr, fr, otherwise English).
export const QUICK_REPLIES: { label: string; text: Record<string, string> }[] = [
    {
        label: 'İsim değiştirme',
        text: {
            tr: 'Merhaba, adınızı şöyle değiştirebilirsiniz: alttaki Ben sekmesi → Profili Düzenle → Ad Soyad → Kaydet. Uygulamayı App Store\'dan güncellemeyi unutmayın.',
            en: 'Hi, you can change your name here: the Me tab at the bottom → Edit Profile → Full Name → Save. Please update LifeShare from the App Store.',
            fr: 'Bonjour, pour changer votre nom : onglet Moi en bas → Modifier le profil → Nom complet → Enregistrer. Pensez à mettre LifeShare à jour.',
        },
    },
    {
        label: 'Çevreden ayrılma',
        text: {
            tr: 'Merhaba, çevreden ayrılmak için Çevrelerim listesinde çevreyi sola kaydırın → Çevreden Ayrıl. Başka bir çevreye katılmak için + → Çevreye Katıl ve davet kodunu girin.',
            en: 'Hi, to leave a circle, swipe it to the left in My Circles → Leave Circle. To join another one, tap + → Join Circle and enter the invite code.',
            fr: 'Bonjour, pour quitter un cercle, glissez-le vers la gauche dans Mes Cercles → Quitter le Cercle. Pour en rejoindre un autre : + → Rejoindre un Cercle, puis le code d\'invitation.',
        },
    },
    {
        label: 'Mil / km',
        text: {
            tr: 'Merhaba, son sürümde LifeShare iPhone\'unuzun ölçü birimini kullanıyor; mesafeler ve hızlar ona göre km ya da mil gösteriliyor.',
            en: 'Hi, in the latest version LifeShare follows your iPhone\'s measurement system, so distances and speeds show in miles when your iPhone uses miles.',
            fr: 'Bonjour, dans la dernière version, LifeShare suit le système de mesure de votre iPhone (km ou miles).',
        },
    },
];

export const quickText = (q: typeof QUICK_REPLIES[number], lang?: string | null) =>
    q.text[lang === 'tr' || lang === 'fr' ? lang : 'en'];
